export const SECONDS_IN_24HRS = 86400;
export const TIMEFRAME_24HRS = { start: 0, end: SECONDS_IN_24HRS };
/**
 * Converts this timeframe to an intrange type
 *
 * Example:
 * Input: {
 *   start: 1,
 *   end: 2
 * }
 *
 * Output: "[1,2)"
 */
export function timeframeToIntRange(timeframe) {
    return `[${timeframe.start},${timeframe.end})`;
}
/**
 * Converts intrange types(i.e int4range or int8range) to a timeframe.
 *
 * Note: Expects inclusive start, exclusive end.
 *
 * Example:
 * Input: "[1,2)"
 *
 * Output: {
 *   start: 1,
 *   end: 2
 * }
 */
export function intRangeToTimeframe(intRange) {
    const results = intRange
        .substring(1, intRange.length - 1)
        .split(',')
        .map(x => Number.parseInt(x, 10));
    return {
        start: results[0],
        end: results[1],
    };
}
export function timecodeToTimeframe(t) {
    return {
        start: t.start.toLocalTime().toSecondOfDay(),
        end: t.end.toLocalTime().toSecondOfDay(),
    };
}
